import { render } from "./Integrations.vue?vue&type=template&id=5c78961e&scoped=true"
const script = {}

import "./Integrations.vue?vue&type=style&index=0&id=5c78961e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c78961e"]])

export default __exports__